import { styled } from '@mui/material/styles';
import { Typography as RaisinTypography } from '@raisin/components-lib';
export const Heading = styled('h5')(({ theme }) => ({
    padding: theme.spacing(6),
    margin: 0,
    fontSize: 18,
    lineHeight: 1.44,
    userSelect: 'none',
}));
export const Anchor = styled('a')(({ theme }) => ({
    display: 'flex',
    textDecoration: 'none',
    padding: theme.spacing(1, 0),
}));
export const Typography = styled(RaisinTypography)(({ theme }) => ({
    color: theme.palette.grey700.main,
    '&:hover, &:focus': {
        color: theme.palette.blue400.main,
    },
    '&:disabled': {
        color: theme.palette.grey400.main,
    },
}));
//# sourceMappingURL=styles.js.map